<template>
  <v-select
    v-model="selectedRecurrence"
    :items="recurrencies"
    item-text="title"
    item-value="id"
    label="Періодичність"
    return-object
    hide-details
    :menu-props="{
      nudgeRight: 30,
      transition: 'scale-transition',
      offsetY: '',
    }"
    dense
    outlined
    @input="selectRecurrence"
  />
</template>

<script>
export default {
  props: ["value"],
  data: () => ({
    selectedRecurrence: null,
    recurrencies: [
      { title: "1 місяць", id: 1 },
      { title: "3 місяці", id: 3 },
      { title: "4 місяці", id: 4 },
      { title: "6 місяців", id: 6 },
      { title: "9 місяців", id: 9 },
      { title: "10 місяців", id: 10 },
      { title: "12 місяців", id: 12 },
      { title: "14 місяців", id: 14 },
      { title: "24 місяців", id: 24 },
      { title: "26 місяців", id: 26 },
      { title: "30 місяців", id: 30 },
    ],
  }),
  watch: {
    value: {
      handler() {
        const recurrence = this.recurrencies.find((el) => el.id === this.value);
        if (recurrence) {
          this.selectedRecurrence = recurrence;
        } else {
          this.selectedRecurrence = this.recurrencies[0];
        }
      },
      immediate: true,
    },
  },
  methods: {
    selectRecurrence() {
      this.$emit("input", this.selectedRecurrence.id);
    },
  },
};
</script>
